import NestedRouteComponent from 'router/nestedViews/NestedRouteComponent';
import wrapLegacyRoute from 'router/legacy/wrapLegacyRoute';
import translation from 'translation';

const roreSitesRoutes = [
  {
    path: 'sites',
    component: NestedRouteComponent,
    meta: {
      routeName: {
        segmentName: () => translation.trc('rore', 'Sites')
      },
      permissions: ['READ_RORE_SITES']
    },
    children: [
      {
        path: '',
        name: 'roreSitesList',
        component: wrapLegacyRoute('roreSitesController', 'list')
      },
      {
        path: 'create',
        name: 'roreSiteCreate',
        component: wrapLegacyRoute('roreSitesController', 'create')
      },
      {
        path: ':siteId(\\d+)',
        name: 'roreSiteDetails',
        component: wrapLegacyRoute('roreSitesController', 'details')
      }
    ]
  },
  {
    path: 'sites/platforms',
    component: NestedRouteComponent,
    meta: {
      routeName: {
        segmentName: () => translation.trc('rore', 'Site Platforms')
      },
      permissions: ['READ_RORE_SITE_PLATFORMS']
    },
    children: [
      {
        path: '',
        name: 'roreSitePlatformsList',
        component: wrapLegacyRoute('roreSitePlatformsController', 'list')
      },
      {
        path: 'create',
        name: 'roreSitePlatformCreate',
        component: wrapLegacyRoute('roreSitePlatformsController', 'create')
      },
      {
        path: ':platformId(\\d+)',
        name: 'roreSitePlatformDetails',
        component: wrapLegacyRoute('roreSitePlatformsController', 'details')
      }
    ]
  },
  {
    path: 'sites/saleshouses',
    component: NestedRouteComponent,
    meta: {
      routeName: {
        segmentName: () => translation.trc('rore', 'Site Sales Houses')
      },
      permissions: ['READ_RORE_SITE_SALES_HOUSES']
    },
    children: [
      {
        path: '',
        name: 'roreSiteSalesHousesList',
        component: wrapLegacyRoute('roreSiteSalesHousesController', 'list')
      },
      {
        path: 'create',
        name: 'roreSiteSalesHouseCreate',
        component: wrapLegacyRoute('roreSiteSalesHousesController', 'create')
      },
      {
        path: ':salesHouseId(\\d+)',
        name: 'roreSiteSalesHouseDetails',
        component: wrapLegacyRoute('roreSiteSalesHousesController', 'details')
      }
    ]
  },
  {
    path: 'sites/types',
    component: NestedRouteComponent,
    meta: {
      routeName: {
        segmentName: () => translation.trc('rore', 'Site Types')
      },
      permissions: ['READ_RORE_SITE_TYPES']
    },
    children: [
      {
        path: '',
        name: 'roreSiteTypesList',
        component: wrapLegacyRoute('roreSiteTypesController', 'list')
      },
      {
        path: 'create',
        name: 'roreSiteTypeCreate',
        component: wrapLegacyRoute('roreSiteTypesController', 'create')
      },
      {
        path: ':typeId(\\d+)',
        name: 'roreSiteTypeDetails',
        component: wrapLegacyRoute('roreSiteTypesController', 'details')
      }
    ]
  }
];

export default roreSitesRoutes;
